

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { YourPersonalDetails } from '../../model/ngrx/your-personal-details.model';

export const ADD_YOUR_PERSONAL_DETAILS = '[YOURPERSONALDETAIL] Add';
export const REMOVE_YOUR_PERSONAL_DETAILS = '[YOURPERSONALDETAIL] Remove';

// AddPersonalDetails
export class AddYourPersonalDetails implements Action {
    readonly type = ADD_YOUR_PERSONAL_DETAILS;

    constructor(public payload: YourPersonalDetails) { }
}
// RemovePersonalDetails
export class RemoveYourPersonalDetails implements Action {
    readonly type = REMOVE_YOUR_PERSONAL_DETAILS;

    constructor(public payload: number) { }
}

export type Actions = AddYourPersonalDetails | RemoveYourPersonalDetails;
